import { filter, forEach, isEmpty, throttle } from 'lodash';
import pt from 'prop-types';
import { Component } from 'react';
import { Subscriber, WindowSize } from './types';

export const SUBSCRIBE_CHANNEL = 'windowSizeSubscribe';
const RESIZE_DEBOUNCE = 200;

export type WindowSizeContext = {
    [key in typeof SUBSCRIBE_CHANNEL]: (subscriber: Subscriber) => () => void;
};

export default class WindowSizeProvider extends Component<React.PropsWithChildren<{}>> {
    static childContextTypes = {
        [SUBSCRIBE_CHANNEL]: pt.func,
    };

    getChildContext(): WindowSizeContext {
        return {
            [SUBSCRIBE_CHANNEL]: this.subscribe,
        };
    }

    componentWillUnmount() {
        this.removeResizeListener();
    }

    getSize = () => ({ width: window.innerWidth, height: window.innerHeight });

    subscribers: Array<Subscriber> = [];

    addResizeListener() {
        window.addEventListener('resize', this.handleResize);
    }

    removeResizeListener() {
        this.handleResize.cancel();
        window.removeEventListener('resize', this.handleResize);
    }

    subscribe = (func: Subscriber) => {
        this.subscribers.push(func);

        if (this.subscribers.length === 1) {
            this.addResizeListener();
        }
        func(this.getSize());

        return () => {
            this.subscribers = filter(this.subscribers, (f) => f !== func);
            if (isEmpty(this.subscribers)) {
                this.removeResizeListener();
            }
        };
    };

    updateSubscribers(size: WindowSize) {
        forEach(this.subscribers, (f) => f(size));
    }

    handleResize = throttle(() => {
        this.updateSubscribers(this.getSize());
    }, RESIZE_DEBOUNCE);

    render() {
        return this.props.children;
    }
}
